var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "export-page p-2 p-md-3"
  }, [_c('b-card', {
    staticClass: "export-card border-0"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-lg-row align-items-lg-center justify-content-between mb-3"
  }, [_c('div', [_c('div', {
    staticClass: "export-kicker"
  }, [_vm._v("Orders Export")]), _c('h3', {
    staticClass: "mb-1"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v("নির্বাচিত status এবং date range অনুযায়ী CSV export করুন।")])]), _c('b-badge', {
    staticClass: "export-status-badge mt-2 mt-lg-0",
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.readableStatus) + " ")])], 1), _c('div', {
    staticClass: "range-tabs-wrap mb-3"
  }, _vm._l(_vm.quickRangeOptions, function (option) {
    return _c('button', {
      key: option.value,
      staticClass: "range-tab-btn",
      class: {
        active: _vm.range === option.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.setRange(option.value);
        }
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  }), 0), _vm.range === 'custom' ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "premium-label"
  }, [_vm._v("From Date")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fromDate,
      expression: "fromDate"
    }],
    staticClass: "form-control premium-date-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.fromDate
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value;
      }
    }
  })]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "premium-label"
  }, [_vm._v("To Date")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.toDate,
      expression: "toDate"
    }],
    staticClass: "form-control premium-date-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.toDate
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value;
      }
    }
  })])], 1) : _vm._e(), _vm.range === 'custom' && _vm.isInvalidCustomRange ? _c('div', {
    staticClass: "text-danger small mb-2"
  }, [_vm._v(" Custom range ব্যবহার করতে From Date এবং To Date দুটোই দিন। ")]) : _vm._e(), _c('div', {
    staticClass: "export-action-wrap"
  }, [_c('button', {
    staticClass: "premium-export-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isDownloading || _vm.isInvalidCustomRange
    },
    on: {
      "click": _vm.downloadCSV
    }
  }, [_c('span', {
    staticClass: "btn-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 3V14",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M8 10L12 14L16 10",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 19H19",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])]), _c('span', [_vm._v(_vm._s(_vm.buttonText))])])]), _vm.isDownloading ? _c('div', {
    staticClass: "export-progress-wrap mt-3"
  }, [_c('div', {
    staticClass: "export-progress-head"
  }, [_c('span', [_vm._v("Preparing export...")]), _c('span', [_vm._v(_vm._s(_vm.progressValue) + "%")])]), _c('div', {
    staticClass: "export-progress-bar"
  }, [_c('div', {
    staticClass: "export-progress-fill",
    style: {
      width: _vm.progressValue + '%'
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "export-help mt-3"
  }, [_vm._v(" CSV fields: Customer Name, Mobile Number, Address, Total Amount ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }